
export const SidebarData = [
  {
    title: "HOME",
    path: "/",
    cName: "nav-text",
  },
  {
    title: "ABOUT ME",
    path: "/about-me",
    cName: "nav-text",
  },
  {
    title: "PROJECTS",
    path: "/projects",
    cName: "nav-text",
  },
  {
    title: "CONTACT ME",
    path: "/contact",
    cName: "nav-text",
  },
];
